import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {dateAgo} from "../../utils";
import styled from "styled-components";
import {
    BodyStyled, SummaryStyled
} from "./CommonStyles";
import ALERT_MAP from "../../maps/alertMap";
import {Link} from "react-router-dom";

const WrapperStyled = styled.div`

`;

const SiteAdminAlerts = ({data, goToAlert, handleStatusChange}) => {
    const [expanded, setExpanded] = React.useState(false);
    const handleAccordinoChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (<WrapperStyled>
        {data.alerts.map((alert, idx) => {
            const type = ALERT_MAP.eventTypes[alert.eventSubType]?.title;

            const severity = alert.severity || 'CRITICAL';

            const alertStatus = alert.status;


            return (
                <Accordion
                    TransitionProps={{unmountOnExit: true}}
                    key={alert._id + idx}
                    expanded={expanded === 'panel' + idx}
                    onChange={handleAccordinoChange('panel' + idx)}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <SummaryStyled style={{gridTemplateColumns: "120px 120px 120px 150px 1fr"}}>
                            <div>
                                {dateAgo(alert.createdAt)}
                            </div>
                            <div>
                                 <span className={`${alert.status} status-class-pouu`}>
                                 {alertStatus}
                                 </span>
                            </div>
                            <div>
                                <span className={severity}>
                                 {severity}
                                </span>
                            </div>
                            <div>
                                {type}
                            </div>
                            <div>
                                {alert.eventEntity}
                            </div>
                        </SummaryStyled>
                    </AccordionSummary>
                    <AccordionDetails>
                        <BodyStyled>
                            {alert.eventEntity === ALERT_MAP.eventEntitys.LOG && (
                                <div>
                                    {alert?.data?.reason}
                                </div>
                            )}
                            {alert.eventEntity === ALERT_MAP.eventEntitys.ALERT && (
                                <div>
                                    <Link to={`/im-alerts?type=${alert.eventSubType}&eventId=${alert._id}`}>
                                        See Alert
                                    </Link>
                                </div>
                            )}
                        </BodyStyled>
                    </AccordionDetails>
                </Accordion>
            );
        })}
    </WrapperStyled>);
};

export default SiteAdminAlerts;